import { useEffect, useState } from "react";
import axios from "axios";
import { HOURS } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Map dayKey ("day.mo") -> settings key ("mo")
const DAY_MAP = { "day.mo": "mo", "day.di": "di", "day.mi": "mi", "day.do": "do", "day.fr": "fr", "day.sa": "sa", "day.so": "so" };

/** Returns HOURS overridden with backend opening_hours (settings.opening_hours). */
export const usePublicHours = () => {
  const [override, setOverride] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then(({ data }) => setOverride(data?.opening_hours || {}))
      .catch(() => setOverride({}));
  }, []);

  if (!override || Object.keys(override).length === 0) return HOURS;

  return HOURS.map((row) => {
    const k = DAY_MAP[row.dayKey];
    const o = k ? override[k] : null;
    if (!o) return row;
    if (o.closed) return { ...row, time: "Geschlossen", closedKey: "day.closed" };
    return { ...row, time: `${o.open} – ${o.close}`, closedKey: undefined };
  });
};
